export const Breakpoints = {
  MOBILE_S: 480,
  MOBILE: 600,
  TABLET: 768,
  TABLET_LANDSCAPE: 1024,
  DESKTOP: 1350,
}

export type ColorType =
  | 'BLACK'
  | 'WHITE'
  | 'BLUE'
  | 'BLACK'
  | 'PALE_BLUE'
  | 'WATERLOO'
  | 'RED'
  | 'BLACKCURRANT'
  | 'SILVER'
  | 'GREEN'
  | 'MARTINIQUE'
  | 'PLUM'
  | 'HAVELOCK_BLUE'
  | 'SHARK'
  | 'AMETHYST'
  | 'WOODSMOKE'
  | 'WOODSMOKE_LIGHT'
  | 'GUN_POWDER'
  | 'CHARADE'
  | 'CINDER'

type ColorsType = {
  [key in ColorType]: string
}

export const Colors: ColorsType = {
  BLACK: '#000000',
  WHITE: '#FFFFFF',
  BLUE: '#3E65DA',
  PALE_BLUE: '#9BB2FF',
  WATERLOO: '#7A7C9A',
  RED: '#DE6161',
  BLACKCURRANT: '#332B43',
  SILVER: '#C4C4C4',
  GREEN: '#48C295',
  MARTINIQUE: '#42325F',
  PLUM: '#882A6E',
  HAVELOCK_BLUE: '#5778DB',
  SHARK: '#1A1B20',
  AMETHYST: '#986DCE',
  WOODSMOKE: '#0D0D11',
  WOODSMOKE_LIGHT: '#17161E',
  GUN_POWDER: '#45465C',
  CHARADE: '#24242F',
  CINDER: '#171121',
}

// Rename to spacing
export type MarginType = 'xxxl' | 'xxl' | 'xl' | 'l' | 'm' | 's' | 'xs' | 'zero'

type MarginsType = {
  [key in MarginType]: number
}

export const Margins: MarginsType = {
  xxxl: 52,
  xxl: 48,
  xl: 40,
  l: 32,
  m: 24,
  s: 16,
  xs: 8,
  zero: 0,
}
